import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { TrashCan } from 'Images';
import { useEffect, useRef } from 'react';

interface IAnotherCaseDetailHeader {
  deleteHandler: Function;
}

export const AnotherCaseDetailHeader = ({
  deleteHandler,
}: IAnotherCaseDetailHeader) => {
  const ref = useRef<HTMLDivElement>();

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  useEffect(() => {
    setTimeout(() => {
      ref.current?.focus();
    }, 0);
  }, []);

  return (
    <Stack
      gap='12px'
      sx={{
        m: '64px 0 12px 0',
      }}
      ref={ref}
      tabIndex={-1}
    >
      <Stack direction='row' justifyContent='space-between'>
        <Typography sx={{ fontWeight: 'bold' }}>
          {dictionary.anotherCaseTitle}
        </Typography>
        <Stack
          direction='row'
          alignItems='center'
          width='fit-content'
          sx={{
            ':hover': {
              cursor: 'pointer',
              textDecoration: 'underline',
            },
          }}
          onClick={() => deleteHandler()}
        >
          <Avatar
            alt=''
            src={TrashCan}
            sx={{
              width: '22px',
              height: '22px',
            }}
          />
          <Typography
            sx={{
              color: '#1752AF',
            }}
          >
            {dictionary.delete}
          </Typography>
        </Stack>
      </Stack>
      <Typography>{dictionary.anotherCaseSubTitle}</Typography>
    </Stack>
  );
};
